<template>
  <div :class="isBurgerMenuOpen ? 'burger-menu-open' : ''" class="fixed-top bg-white">
    <nav class="navbar lg:max-w-7xl lg:mx-auto pt-1 px-2 z-20">
      <div class="sm:px-4 lg:px-8 lg:py-4 flex flex-wrap items-center justify-between lg:flex-nowrap">
        <!-- Text Logo - Use this if you don't have a graphic logo -->
        <!-- <a class="text-gray-800 font-semibold text-3xl leading-4 no-underline page-scroll" href="index.html">Pavo</a> -->

        <!-- Image Logo -->
        <a class="inline-block mr-4 pt-0.5 text-xl whitespace-nowrap hover:no-underline focus:no-underline" href="/">
          <img src="images/logo.svg" alt="alternative" class="h-12 lg:h-16" />
        </a>

        <button class="flex lg:hidden" type="button" @click="toggleNav">
          <div class="hamburger-lines">
            <span class="line line1" />
            <span class="line line2" />
            <span class="line line3" />
          </div>
        </button>
        <div :class="isBurgerMenuOpen ? 'open' : ''" class="navbar-collapse offcanvas-collapse lg:flex lg:flex-grow lg:items-center bg-white text-lg">
          <ul class="pl-0 mt-5 mb-2 ml-auto flex flex-col list-none lg:mt-0 lg:mb-0 lg:flex-row">
            <li v-for="(item, index) in navItems" :key="index" class="py-2">
              <a :class="isNavItemActive(item.route) ? 'active' : ''" class="nav-link page-scroll" :href="item.route">{{ item.title }}</a>
            </li>
          </ul>
        </div>
        <!-- end of navbar-collapse -->
      </div>
      <!-- end of container -->
    </nav>
    <div class="navbar-shadow" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isBurgerMenuOpen: false,
      navItems: this.$page.props.nav_items.header,
    }
  },
  methods: {
    toggleNav: function () {
      this.isBurgerMenuOpen = !this.isBurgerMenuOpen
    },
    isNavItemActive: function (url) {
      let currentUrl = this.$page.url
      url = url.replace(this.$page.props.base_url, '')
      if (url == '/') {
        return currentUrl == '/'
      }
      return currentUrl.startsWith(url)
    },
  },
}
</script>
